/* eslint-disable  */
import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { BarChart, Bar, Cell, ResponsiveContainer } from 'recharts';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

class Subscriptions extends PureComponent {
	static propTypes = {
		t: PropTypes.func.isRequired,
	};

	constructor() {
		super();
		this.state = {
			activeIndex: 0,
		};

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick = (item) => {
		const data = this.props.rdata;
		const index = data.indexOf(item.payload);
		this.setState({
			activeIndex: index,
		});
	};

	render() {
		const data = this.props.rdata;
		const { activeIndex } = this.state;
		const activeItem = data[activeIndex];
		const { t } = this.props;

		return (
			<Col md={12} xl={3} lg={6} xs={12}>
				<Card>
					<CardBody className="dashboard__card-widget">
						<div className="card__title">
							<h5 className="bold-text">{this.props.tname}</h5>
						</div>
						<div className="dashboard__total">
							<TrendingUpIcon className="dashboard__trend-icon" />
							<p className="dashboard__total-stat">{activeItem.pv}</p>
							<div className="dashboard__chart-container">
								<ResponsiveContainer height={50}>
									<BarChart data={data}>
										<Bar dataKey="pv" onClick={this.handleClick}>
											{data.map((entry, index) => (
												<Cell
													cursor="pointer"
													fill={index === activeIndex ? '#4ce1b6' : '#f6da6e'}
													key={`cell-${index}`}
												/>
											))}
										</Bar>
									</BarChart>
								</ResponsiveContainer>
							</div>
						</div>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default withTranslation('common')(Subscriptions);
